export async function getAiConversations(token) {
  return request("/api/ai/conversations", {
    method: "GET",
    token: token
  });
}

export async function createAiConversation(payload, token) {
  return request("/api/ai/conversations", {
    method: "POST",
    token: token,
    body: payload
  });
}

export async function getAiConversationDetail(id, token) {
  return request("/api/ai/conversations/" + id, {
    method: "GET",
    token: token
  });
}

export async function deleteAiConversation(id, token) {
  return request("/api/ai/conversations/" + id, {
    method: "DELETE",
    token: token
  });
}

export async function getAiImages(token) {
  return request("/api/ai/images", {
    method: "GET",
    token: token
  });
}

export async function createAiImage(payload, token) {
  return request("/api/ai/images", {
    method: "POST",
    token: token,
    body: payload
  });
}

export async function getAiImageDetail(id, token) {
  return request("/api/ai/images/" + id, {
    method: "GET",
    token: token
  });
}

export async function updateAiImageVisibility(id, messageId, payload, token) {
  return request("/api/ai/images/" + id + "/messages/" + messageId + "/visibility", {
    method: "PATCH",
    token: token,
    body: payload
  });
}

export async function deleteAiImage(id, token) {
  return request("/api/ai/images/" + id, {
    method: "DELETE",
    token: token
  });
}

export async function getAiVideos(token) {
  return request("/api/ai/videos", {
    method: "GET",
    token: token
  });
}

export async function createAiVideo(payload, token) {
  return request("/api/ai/videos", {
    method: "POST",
    token: token,
    body: payload
  });
}

export async function uploadAiImageFile(file, token) {
  var formData = new FormData();
  formData.append("image", file);

  return multipartRequest("/api/ai/uploads/images", {
    method: "POST",
    token: token,
    body: formData
  });
}

export async function getAiVideoDetail(id, token, params) {
  var query = params || {
    refresh: "false"
  };

  return request("/api/ai/videos/" + id + buildQueryString(query), {
    method: "GET",
    token: token
  });
}

export async function updateAiVideoVisibility(id, messageId, payload, token) {
  return request("/api/ai/videos/" + id + "/messages/" + messageId + "/visibility", {
    method: "PATCH",
    token: token,
    body: payload
  });
}

export async function deleteAiVideo(id, token) {
  return request("/api/ai/videos/" + id, {
    method: "DELETE",
    token: token
  });
}

export async function getAiPointCosts(token) {
  return request("/api/ai/point-costs", {
    method: "GET",
    token: token
  });
}

export async function getAiSpeeches(token) {
  return request("/api/ai/speeches", {
    method: "GET",
    token: token
  });
}

export async function createAiSpeech(payload, token) {
  return request("/api/ai/speeches", {
    method: "POST",
    token: token,
    body: payload
  });
}

export async function getAiSpeechDetail(id, token) {
  return request("/api/ai/speeches/" + id, {
    method: "GET",
    token: token
  });
}

export async function deleteAiSpeech(id, token) {
  return request("/api/ai/speeches/" + id, {
    method: "DELETE",
    token: token
  });
}

export async function getSquare(params, token) {
  return request("/api/square" + buildQueryString(params), {
    method: "GET",
    token: token
  });
}

export async function sendAiConversationMessage(id, payload, token) {
  return request("/api/ai/conversations/" + id + "/messages", {
    method: "POST",
    token: token,
    body: payload
  });
}

export async function streamAiConversationMessage(id, payload, token, handlers) {
  var response = await fetch("/api/ai/conversations/" + id + "/messages/stream", {
    method: "POST",
    headers: {
      Accept: "text/event-stream",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    var contentType = response.headers.get("content-type") || "";
    var data = null;

    if (contentType.indexOf("application/json") > -1) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    var error = new Error(resolveErrorMessage(response.status, data));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  var reader = response.body.getReader();
  var decoder = new TextDecoder("utf-8");
  var buffer = "";

  while (true) {
    var result = await reader.read();

    if (result.done) {
      break;
    }

    buffer += decoder.decode(result.value, { stream: true });

    var blocks = buffer.split("\n\n");
    buffer = blocks.pop() || "";

    blocks.forEach(function(block) {
      processSseBlock(block, handlers);
    });
  }

  if (buffer.trim()) {
    processSseBlock(buffer, handlers);
  }
}

async function request(url, options) {
  var settings = options || {};
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  if (settings.token) {
    headers.Authorization = "Bearer " + settings.token;
  }

  var response = await fetch(url, {
    method: settings.method || "GET",
    headers: headers,
    body: settings.body ? JSON.stringify(settings.body) : undefined
  });

  var data = null;
  var contentType = response.headers.get("content-type") || "";

  if (contentType.indexOf("application/json") > -1) {
    data = await response.json();
  } else if (response.status !== 204) {
    data = await response.text();
  }

  if (!response.ok) {
    var error = new Error(resolveErrorMessage(response.status, data));
    error.status = response.status;
    error.data = data;
    error.validationErrors = data && data.errors ? data.errors : null;
    throw error;
  }

  return data;
}

async function multipartRequest(url, options) {
  var settings = options || {};
  var headers = {
    Accept: "application/json"
  };

  if (settings.token) {
    headers.Authorization = "Bearer " + settings.token;
  }

  var response = await fetch(url, {
    method: settings.method || "POST",
    headers: headers,
    body: settings.body
  });

  var data = null;
  var contentType = response.headers.get("content-type") || "";

  if (contentType.indexOf("application/json") > -1) {
    data = await response.json();
  } else if (response.status !== 204) {
    data = await response.text();
  }

  if (!response.ok) {
    var error = new Error(resolveErrorMessage(response.status, data));
    error.status = response.status;
    error.data = data;
    error.validationErrors = data && data.errors ? data.errors : null;
    throw error;
  }

  return data;
}

function resolveErrorMessage(status, data) {
  if (status === 422 && data && data.errors) {
    var firstKey = Object.keys(data.errors)[0];
    if (firstKey && data.errors[firstKey] && data.errors[firstKey][0]) {
      return data.errors[firstKey][0];
    }
  }

  if (data && data.message) {
    return data.message;
  }

  if (status === 401) {
    return "登录状态已失效，请重新登录。";
  }

  if (status === 404) {
    return "会话不存在。";
  }

  if (status === 500) {
    return "服务器异常，请稍后重试。";
  }

  return "请求失败，请稍后重试。";
}

function buildQueryString(params) {
  var source = params || {};
  var pairs = Object.keys(source).filter(function(key) {
    return source[key] !== undefined && source[key] !== null && source[key] !== "";
  }).map(function(key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(source[key]);
  });

  return pairs.length ? "?" + pairs.join("&") : "";
}

function processSseBlock(block, handlers) {
  var lines = block.split("\n");
  var eventName = "";
  var dataText = "";

  lines.forEach(function(line) {
    if (line.indexOf("event:") === 0) {
      eventName = line.slice(6).trim();
    }

    if (line.indexOf("data:") === 0) {
      dataText += line.slice(5).trim();
    }
  });

  if (!eventName || !dataText) {
    return;
  }

  var parsed = JSON.parse(dataText);

  if (eventName === "delta" && handlers && handlers.onDelta) {
    handlers.onDelta(parsed);
  }

  if (eventName === "done" && handlers && handlers.onDone) {
    handlers.onDone(parsed);
  }

  if (eventName === "error" && handlers && handlers.onError) {
    handlers.onError(parsed);
  }
}
